export const EVENT_PROFILE_EMAIL_TAKEN =
  "A participant with this email already exists in this event";

export function collectInvitationEmails(
  ...emails: Array<string | null | undefined>
): string[] {
  const seen = new Set<string>();
  for (const email of emails) {
    const normalized = email?.trim().toLowerCase();
    if (normalized) seen.add(normalized);
  }
  return [...seen];
}

export function pickPreviousInvitationEmail(
  profileEmail?: string | null,
  userEmail?: string | null,
  companyEmail?: string | null
): string | undefined {
  return collectInvitationEmails(profileEmail, userEmail, companyEmail)[0];
}

export function eventProfileEmailConflicts(opts: {
  occupantProfileId: string;
  occupantUserId?: string | null;
  currentProfileId?: string | null;
  currentUserId?: string | null;
}): boolean {
  if (opts.currentProfileId && opts.occupantProfileId === opts.currentProfileId) {
    return false;
  }
  if (
    opts.currentUserId &&
    opts.occupantUserId &&
    opts.occupantUserId === opts.currentUserId
  ) {
    return false;
  }
  return true;
}
